import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';
import { SideMenuFilterItem } from '@vlabs/monokit/shared/ui/side-menu-filter-item';

// eslint-disable-next-line import-x/no-namespace
import * as Popovers from './popovers';

const withLeftPopover = withPopover({ placement: 'left' });

const withSideMenuItemLeftPopover = withLeftPopover(SideMenuFilterItem);

export const DateFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.DateFilterPopover);
export const ExternalIdFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.CardIdFilterPopover);
export const FioFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.FioFilterPopover);
export const ListsFilterWithLeftPopover = withSideMenuItemLeftPopover(Popovers.ListsFilterPopover);
